<template>
    <div
      class="offer"
      :class="[offer.offerSubtypes, offer.state]"
      :id="'offer-' + offer.id"
      v-show="getFinishedOffers()"
    >
      <div class="offer__header" @click="market ? null : toggleOfferId(offer.id)">
  
        
        <div class="infotip pr-2" v-if="createdByAgent">
          <div
            class="infotip__host"
            aria-controls="infotip-overlay"
            aria-expanded="true"
            aria-label="Help"
          >
          <span class="material-icons">assignment_ind </span>
          </div>
            <span class="infotip__live-region" aria-live="off">
              <div class="infotip__overlay" id="infotip-overlay">
                <div class="infotip__overlay-content">
                  Oferta creada por un administrador
                </div>
              </div>
            </span>
        </div>
  
  
  
        <div class="header-offer-type">
          <div> {{ $t(`offer.type.${offer.offerType}`) }}
           
          <span class="offer-muvin-tag" data-test="offer-id" v-if="offer.subtype === 'muvin'"><b>Oferta Muvin</b></span>
          </div>
           <span class="offer-id" data-test="offer-id">#{{ offer.id }}</span>
        </div>
        <div class="header-offer-right">
          <div v-if="showOfferState && offer.alreadyPublishedInMuvin" class="header-offer-status muvin" :class="offer.state">
            Publicada en muvin
          </div>
          <div
            v-if="showOfferState"
            class="header-offer-status"
            :class="offer.state"
          >
            {{ $t(`offer.state.${offer.state}`) }}
          </div>

          <div
            class="header-offer-pending"
            data-test="statusPending"
            v-if="
              [
                'published',
                'in_negotiation',
                'pending',
              ].includes(offer.state) &&
                !!getPendingNegotiations(offer) &&
                !admin && this.filterType !== 'finishedNegotiations' &&
                offer.subtype != 'muvin'
            "
          >
            <vs-icon icon="priority_high" />
            <span
              >{{
                getPendingNegotiations(offer) > 1
                  ? getPendingNegotiations(offer) + " pendientes"
                  : "Pendiente"
              }}
              de respuesta</span
            >
          </div>
          <div
            class="header-offer-date"
            v-if="
              ['published', 'in_negotiation', 'accept_pending'].includes(
                offer.state
              )
            "
          >
            <vs-icon icon="access_time" />
            Vence en {{ daysLeft(offer.dueAt) }} días
          </div>
          <div
            v-if="offer.securePayment"
            class="header-offer-secure-payment"
            :class="{ active: !['finished', 'expired'].includes(offer.state) }"
          >
            <button class="btn btn--with-icon btn--small">
              <img alt="Pago seguro" src="@/assets/images/secure.svg" />
              <span>
                Pago seguro
              </span>
            </button>
          </div>
          <div
            class="header-offer-download"
            v-if="offer.pdfUrl || haveNegotiationPdfUrl"
          >
            <button
              v-if="getNegotiationState()"
              class="btn btn--with-icon btn--small pdf-download"
              @click.stop="getPdf(offer)"
            >
              <img alt="Descargar comprobante" src="@/assets/images/pdf.svg" />
              <span>Descargar comprobante</span>
            </button>
          </div>
          <!-- TODO: dinamizar comportamiento btn cancel -->
          <!-- <div class="header-offer-actions we-dropdown" @click.stop="toggleDropdown()">
            <vs-icon icon="more_vert"/>
            <div class="we-dropdown-menu" :class="{'is-visible' : dropdownVisible}">
              <span @click="toggleOfferId(offer.id)"> <vs-icon icon="add_circle"/>Ver detalle</span>
              <a> <vs-icon icon="close"/>Cancelar oferta</a>
            </div>
          </div>
  
          <button v-if="!offer.canOperate" @click.stop="confirmAction = true">cancelar</button>
  
          <div v-if="confirmAction" class="confirm-action">
            <div class="message">
              ¿Está seguro que desea cancelar la oferta?
            </div>
            <div class="negotiation-actions">
              <button data-test="button-cancelNegotiation" class="btn btn-secondary" type="flat" icon="close" @click.stop="confirmAction=false"> Cancelar</button>
              <button data-test="button-confirmNegotiation" class="btn btn--inverted success" type="flat" icon="check" @click.stop="cancelOffer"> Confirmar</button>
            </div>
          </div>
          -->
        <!--  <div v-if="offer.part.opener.organizationId == this.currentUser.organizationId">
            <button class="btn btn--with-icon we-dropdow-toggle button-clone" @click.stop="showCloneMenu = !showCloneMenu">
              <vs-icon icon="settings"></vs-icon>
            </button>
               <div class="we-dropdown-menu dropdown-menu--right" :class="{ 'is-visible' : showCloneMenu }">
              <span @click.stop="cloneOffer(offer.offerType.split('_')[1])">
                Clonar oferta
              </span>
            </div> 
          </div>-->
          <div class="header-offer-expand" :class="{ expanded: offerId }">
            <vs-icon icon="keyboard_arrow_down" />
          </div>
        </div>
      </div>
      <div class="offer__content">
        <transition name="offer-fade">
          <div
            v-if="!offerId"
            class="offer__summary"
            @click="market ? null : toggleOfferId(offer.id)"
          >
            <div class="summary-week">
              <div>
                <label>
                  Entrega
                </label>
              </div>
              <div>
                <strong>Semana {{ weekNumber(offer.week) }}</strong>
              </div>
              <div class="week-time">
                {{ weekRange(offer.week) }}
              </div>
            </div>
  
            <div class="summary-info">
              <span>
                <label>Cantidad y tipo</label>
                <strong
                  :class="offer.negotiableAttributes ? { negotiable: offer.negotiableAttributes.quantity } : ''"
                >
                  <span class="wrapper">
                    {{ showQuantityLeft }}
                    <span v-if="offer.subtype != 'muvin' && offer.negotiableAttributes.quantity" class="icon">
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/negotiate.svg"
                      />
                    </span>
                  </span>
                  {{ offer.category.name | mei}}
                </strong>
              </span>
              <span class="open-market" v-if="offer.subtype != 'muvin'">
                <label>
                  Peso faena
                </label>
                <strong
                  :class="{
                    negotiable: offer.negotiableAttributes.slaughterWeight
                  }"
                >
                  <span class="wrapper">
                    {{ offer.quality.slaughterWeight.replace(".", ",") }} (± 5)
                    Kgs
                    <span
                      v-if="offer.negotiableAttributes.slaughterWeight"
                      class="icon"
                    >
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/negotiate.svg"
                      />
                    </span>
                  </span>
                </strong>
              </span>
              <span>
                <label>
                  Precio inicial sin IVA
                </label>
                <strong 
                  :class="offer.negotiableAttributes ? { negotiable: offer.negotiableAttributes.price } : ''">
                  <span class="wrapper">
                    {{ localePrice(offer.price) }}
                    <span v-if="offer.subtype != 'muvin' && offer.negotiableAttributes.price" class="icon">
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/negotiate.svg"
                      />
                    </span>
                  </span>
                </strong>
              </span>
              <span v-if="offer.kilometers === 0 || offer.kilometers > 0">
                <label>
                  Kms
                </label>
                <strong>
                  <span class="wrapper">
                    {{ offer.kilometers ? offer.kilometers : "-" }}
                  </span>
                </strong>
              </span>
            </div>
  
            <div class="summary-part">
              <div class="summary-part__origin">
                <label>
                  Origen
                </label>
                <strong>
                  <template v-if="offer.offerType.split('_')[1] === 'sell'">
                    <span data-test="identityShow">
                      {{ offer.displayName }}
                    </span>
                  </template>
                  <template v-else>
                    <span data-test="identityShow" v-if="showEstablishmentOrigin()">
                      {{ offer.part.origin.organization.businessName }},
                      {{ offer.part.origin.name }}
                    </span>
                    <span v-else class="open-market">
                      Mercado
                    </span>
                  </template>
                </strong>
              </div>
  
              <div class="summary-part__destination">
                <strong>
                  <div v-if="offer.subtype != 'muvin'">
                    <label>Destino</label>
                    <template v-if="offer.offerType.split('_')[1] === 'buy'">
                      <span data-test="identityShow">
                        {{ offer.displayName }}
                      </span>
                    </template>
                    <template v-else>
                      <span data-test="identityShow" v-if="showEstablishmentDestination()">
                        {{ offer.part.destination.organization.businessName }},
                        {{ offer.part.destination.name }}
                      </span>
                      <span v-else class="open-market">
                        Mercado
                      </span>
                    </template>
                  </div>
                  <div v-else>
                    <label>Organización destino</label>
                    <span class="open-market">{{ offer.part.destinationOrganization ? offer.part.destinationOrganization.businessName : '-'}}</span>
                  </div>
                </strong>
              </div>
            </div>
          </div>
        </transition>
        <DeliveryDetails
          v-show="offerId"
          @reload-published-offers="reloadPublishedOffers"
          ref="offerDetails"
          :filterType="filterType"
          :admin="admin"
          :originalOffer="offer"
        />
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations } from 'vuex'
  import gql from 'graphql-tag'
  import axios from 'axios'
  import { print } from 'graphql'
  import DeliveryDetails from './DeliveryDetails.vue'
 
  const transactionateOffer = gql`
    mutation transactionateOffer(
      $currentUserToken: String!
      $offerId: Int!
      $action: String!
    ) {
      transactionateOffer(
        currentUserToken: $currentUserToken
        offerId: $offerId
        action: $action
      ) {
        code
        message
        success
      }
    }
  `
  
  export default {
    name: 'delivery-list-row',
    props: {
      offer: {
        type: Object,
        required: true
      },
      market: {
        type: Boolean,
        required: false,
        default: false
      },
      filterType: {
        type: String,
        required: false,
        default: 'activeOffers'
      },
      admin: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    components: {
    DeliveryDetails
},
    computed: {
      ...mapState({
        offers: state => state.Offer.offersGroup,
        currentUser: state => state.User.currentUser
      }),
      haveNegotiationPdfUrl () {
        if (this.offer.negotiations) {
          if (
            this.offer.negotiations.filter(
              ng => ng.pdfUrl && ng.state == 'accepted'
            ).length
          ) {
            return true
          }
        }
        return false
      },
      showQuantityLeft () {
        if (this.offer.quantityLeft != this.offer.quantity) {
          return `${this.offer.quantityLeft} de ${this.offer.quantity}`
        }
        return this.offer.quantity
      },
      createdByAgent(){
        if (this.offer.agent !== null) {
          // SOLO LO VE ADM Y USUARIO AL QUE SE LE CREA LA OFERTA, NO LA CONTRAPARTE, SACAR SI LO TIENEN QUE VER TODOS
          if (this.offer.part.opener.organizationId === this.currentUser.organizationId || this.currentUser.organizationId === null) {
            return true
          }
        }
        return false
      },
      showOfferState () {
        if(this.offer.negotiations.length > 0 && this.offer.negotiations[this.offer.negotiations.length - 1 ].state == 'rejected' && this.offer.state == 'in_negotiation'){
          this.offer.state = 'published'
            return true
          }
  
          if(this.offer.negotiations.length > 0 && this.offer.negotiations[this.offer.negotiations.length - 1 ].state == 'cancelled' && this.offer.state == 'in_negotiation'){
            this.offer.state = 'published'
            return true
          }
  
        let acceptedOffer = this.offer.negotiations.filter(ng => ng.state === 'accepted' && this.currentUser.organizationId == ng.receiverId)
        if(this.filterType == "finishedNegotiations" && this.offer.state === 'in_negotiation' && acceptedOffer.length > 0){
          this.offer.state = 'finished';
          return true
        }
  
        if (this.offer.state === 'in_negotiation') {
          if (!this.offer.negotiations.filter(ng => ng.state === 'pending').length) {
            return false
          }
        }
  // OCULTAR LABEL PENDIENTE EN FINALIZADAS
        if(this.offer.state === 'accept_pending' && this.filterType === 'finishedNegotiations'){
          this.offer.state = 'finished'
          return true
        }
  
        return true
      },
      isActive() {
        var estabArr = this.currentUser.organization.establishments;
        var active = estabArr.filter(estab => estab.active == true);
        return active.length;
      }
    },
    data () {
      return {
        offerId: '',
        railsLink: process.env.VUE_APP_RAILS_PATH,
        location: location,
        clicked: false,
        dropdownVisible: false,
        confirmAction: false,
        showCloneMenu: false,
      }
    },
    // revisar filtros.
    methods: {
      getNegotiationState (){
          
        let negoStates = this.offer.negotiations.slice(0, 2)
        let orgId =  this.currentUser.organizationId
        let negoStateRejected = negoStates.find(n => n.state === 'rejected' && (n.receiverId == orgId || n.senderId == orgId))
        let negoStateAccepted = negoStates.find(n => n.state === 'accepted' && n.receiverId == orgId)
          
        // if(this.offer.state == 'finished' && !negoStateRejected && [this.offer.negotiations[0].receiverId, this.offer.negotiations[0].senderId].includes(this.currentUser.organizationId)) return true;
        
        if(!negoStateAccepted){
          if (negoStateRejected) {
            if ( this.offer.part.opener.organizationId !== this.currentUser.organizationId && ['finished'].includes(this.offer.state) && [this.offer.negotiations[0].receiverId, this.offer.negotiations[0].senderId].includes(this.currentUser.organizationId) ) {
              return false;
            } 
          }else if (this.offer.state === 'accept_pending' && this.offer.part.opener.organizationId !== this.currentUser.organizationId){
            return false
          }
        }
        return true;
      },
  
      getPdf (offer) {
        let negoStates = this.offer.negotiations
        let negoStateAccepted = negoStates.filter(n => n.state === 'accepted')
        if ( negoStateAccepted.length >= 1) {
          if (!this.clicked) {
           this.$refs.offerDetails.openHistory = true
           if (!this.offerId) {
             this.offerId = this.offer.id
             this.$refs.offerDetails.open(this.offer.id)
           }  else {
             this.$refs.offerDetails.openHistory = true
            }
          }
        } else {
          location.replace(`${this.railsLink}${offer.pdfUrl}.pdf`)
        }
      },
      // OCULTAR OFERTAS FINALIZADAS EN NEGOCIACIONES ACTIVAS
      getFinishedOffers(){
        // MOSTRAR OFERTAS EN ADMIN
        if (this.currentUser.admin) {
          return ['order_muvin_published', 'order_muvin_pending', 'order_muvin_expired', 'order_muvin_finished'].includes(this.offer.state)
        }
  
        // ACTIVAS
        if (this.filterType === 'activeNegotiations' ) {
          return (this.offer.state !== 'finished');
        }
        // NEGOCIACIONES ACTIVAS EN MIS OFERTAS
        if(this.filterType === 'activeOffers') {
          // MUESTRA COMO ACTIVAS EN MIS OFERTAS LAS QUE NO SEAN FINALIZADAS Y LAS QUE NO TENGAN REJECTED EN NEGOCIACION
          return ((this.offer.state !== 'finished' && this.offer.state !== 'cancelled' && (this.offer.negotiations.length === 0 || this.offer.negotiations.find(n => n.state !== 'rejected'))) || (this.offer.state === 'published' || this.offer.state === 'accept_pending'))
        }
        // FINALIZADAS EN NEGOCIACIONES Y MIS OFERTAS
        if ( this.filterType === 'finishedOffers') {
          return ((this.offer.state === 'finished' && this.offer.state === 'expired' && (this.offer.negotiations.length === 0 || this.offer.negotiations.find(n => n.state === 'rejected'))) || (this.offer.state !== 'published' || this.offer.state !== 'accept_pending'))

        }
      },
      getPendingNegotiations (offer) {
        let pendingNegotiations = 0
        if (['order_muvin_finished', 'cancelled'].includes(offer.state)) {
          return false
        }
        if (offer.pendingOperations) {
          if (offer.negotiations.length > 0) {
            pendingNegotiations = offer.negotiations.filter(
              ng =>
                ng.state === 'pending' &&
                ng.senderId !== this.currentUser.organizationId
            ).length
          } else if (
            this.currentUser.organizationId != offer.part.opener.organizationId
          ) {
            pendingNegotiations = 1
          }
        }
        return pendingNegotiations
      },
      getActiveNegotiations (offer) {
        let activeNegotiations = 0
        if (['order_muvin_finished', 'cancelled'].includes(offer.state)) {
          return false
        }
        if (offer.pendingOperations) {
          if (offer.negotiations.length > 0) {
            activeNegotiations = offer.negotiations.filter(
              ng => ng.state === 'pending'
            ).length
          } else if (
            this.currentUser.organizationId != offer.part.opener.organizationId
          ) {
            activeNegotiations = 1
          }
        }
        return activeNegotiations
      },
      toggleOfferId (id) {
        this.$refs.offerDetails.openHistory = false
        if (this.offerId) {
          this.offerId = ''
        } else {
          this.offerId = id
          this.$refs.offerDetails.open(id)
        }
      },
      toggleDropdown (id) {
        this.dropdownVisible = !this.dropdownVisible
      },
      daysLeft (endDate) {
        let startDate = new Date().toISOString().slice(0, 10)
        let timeDiff = new Date(endDate) - new Date(startDate)
        let days = timeDiff / (1000 * 60 * 60 * 24)
        return (days >= 0) ? days : 0   // Si la resta da algun numero menor a 0, que retorne 0 para que visualmente no exista el caso de vencimiento en -n dias
      },
      reloadPublishedOffers () {
        this.$emit('reload-published-offers')
      },
      localePrice (price) {
        return '$/Kg ' + price.toLocaleString('es', { minimumFractionDigits: 2 })
      },
      localeDate (str) {
        return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString()
      },
      weekRange (offerWeek) {
        const week = offerWeek.toString().slice(-2)
        const year = offerWeek.toString().substr(0, 4)
        return `${this.getFirstDayOfWeek(week, year)} - ${this.getLastDayOfWeek(
          week,
          year
        )}`
      },
      getFirstDayOfWeek (week, year) {
        var date = this.getDateOfWeek(week, year)
        date = date
          .toJSON()
          .split('T')[0]
          .split('-')
        return `${date[2]}/${date[1]}/${date[0]}`
      },
      getLastDayOfWeek (week, year) {
        var date = this.getDateOfWeek(week, year)
        date.setDate(date.getDate() + 6)
        date = date
          .toJSON()
          .split('T')[0]
          .split('-')
        return `${date[2]}/${date[1]}/${date[0]}`
      },
      getDateOfWeek(week, year) {
        let day = new Date(year, 0, 1 + (week - 1) * 7);
        let dayOfWeek = day.getDay();
        let weekStart = day;
        if (dayOfWeek <= 7) {
            weekStart.setDate(day.getDate() - day.getDay() + 1);
        } else {
            weekStart.setDate(day.getDate() + 8 - day.getDay());
        }
        if (year == 2023) {
            weekStart.setDate(weekStart.getDate() - (7));
        }
        return weekStart;
      },
      weekNumber (week) {
        return week.toString().slice(-2)
      },
      showEstablishmentOrigin(){
        if (this.offer.part.origin != null) {
          if (this.currentUser.admin) {
            return true
          }
          let establishmentIds = this.currentUser.organization.establishments.map(e => e.id) 
          if (!establishmentIds.includes(this.offer.part.origin.id) && !establishmentIds.includes(this.offer.part.destination.id)){
          return false
          }
        } else {
          return false
        }
        return true
      },
      showEstablishmentDestination(){
        if (this.offer.part.destination != null) {
          if (this.currentUser.admin) {
            return true
          }
          let establishmentIds = this.currentUser.organization.establishments.map(e => e.id) 
          if (!establishmentIds.includes(this.offer.part.destination.id) && !establishmentIds.includes(this.offer.part.origin.id)) {
          return false
          }
        } else {
          return false
        }
        return true
      },
      cancelOffer () {
        axios
          .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
            query: print(transactionateOffer),
            variables: {
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              offerId: this.offer.id,
              action: 'cancel!'
            }
          })
          .then(res => {
            if (!res.data.errors) {
              if (res.data.data.transactionateOffer.success) {
                this.error = ''
                // this.$emit('close-sidebar')
                // this.notify(this.offerAction)
                // this.cleanActions()
                this.confirmAction = false
                this.reloadPublishedOffers()
                this.$vs.notify({
                  title: 'Oferta cancelada',
                  time: 8000,
                  text: 'La operación ha sido cancelada con éxito',
                  color: '#50b83d',
                  position: 'top-right',
                  icon: 'check_circle'
                })
                console.log('cancelled')
              } else {
                console.log(res.data.data.transactionateOffer.code)
              }
            }
          })
      },
  
      cloneOffer(offerType) {
        if (this.isActive) {
          this.$router.push(`clone-offer/${offerType}/${this.offer.id}`);
        } else {
          this.$vs.notify({
            title: "Error",
            time: 8000,
            text:
              "Usted no posee establecimientos habilitados para crear una oferta.",
            color: "#eb4d4b",
            position: "top-center",
            icon: "error"
          });
        }
      }
  
    }
  }
  </script>
  